// extracted by mini-css-extract-plugin
export default {"GraphStat_container":"styles_GraphStat_container__ENPv6","icon":"styles_icon__4Lc4e","title":"styles_title__8qEdc","value":"styles_value__AMUgi"};